import React, { useState } from 'react';
import { TrendingUp, Clock, CheckCircle, DollarSign, Calendar, ChevronDown, ArrowUpRight, CreditCard, Download, Filter } from 'lucide-react';
export function EarningsPage() {
  const [period, setPeriod] = useState('Questa Settimana');
  const transactions = [{
    id: 1,
    date: '3 Feb 2026',
    desc: 'Pulizia Via Cola di Rienzo 28',
    jobs: '3 lavori',
    amount: '€140',
    status: 'paid'
  }, {
    id: 2,
    date: '5 Feb 2026',
    desc: 'Pulizia Via del Corso 150',
    jobs: '1 lavoro',
    amount: '€50',
    status: 'processing'
  }, {
    id: 3,
    date: '6 Feb 2026',
    desc: 'Pulizia Via della Lungaretta 12',
    jobs: '4 lavori',
    amount: '€180',
    status: 'paid'
  }, {
    id: 4,
    date: '7 Feb 2026',
    desc: 'Sanificazione Via Marmorata 32',
    jobs: '1 lavoro',
    amount: '€75',
    status: 'paid'
  }, {
    id: 5,
    date: '8 Feb 2026',
    desc: 'Pulizia Via dei Parioli 18',
    jobs: '2 lavori',
    amount: '€95',
    status: 'scheduled'
  }];
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'paid':
        return <span className="bg-green-100 text-green-700 px-2.5 py-0.5 rounded-full text-xs font-medium" data-id="element-144">
            Pagato
          </span>;
      case 'processing':
        return <span className="bg-amber-100 text-amber-700 px-2.5 py-0.5 rounded-full text-xs font-medium" data-id="element-145">
            In Elaborazione
          </span>;
      case 'scheduled':
        return <span className="bg-blue-100 text-blue-700 px-2.5 py-0.5 rounded-full text-xs font-medium" data-id="element-146">
            Programmato
          </span>;
      default:
        return null;
    }
  };
  // Mock data for chart
  const chartData = [{
    day: 'Lun',
    value: 140
  }, {
    day: 'Mar',
    value: 220
  }, {
    day: 'Mer',
    value: 180
  }, {
    day: 'Gio',
    value: 340
  }, {
    day: 'Ven',
    value: 290
  }, {
    day: 'Sab',
    value: 450
  }, {
    day: 'Dom',
    value: 190
  }];
  const maxVal = Math.max(...chartData.map(d => d.value));
  return <div className="space-y-8" data-id="element-147">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-148">
        <div data-id="element-149">
          <h1 className="text-xl lg:text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-150">
            Guadagni
          </h1>
          <p className="text-sm text-gray-500" data-id="element-151">
            Monitora le tue entrate e le prestazioni finanziarie
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-152">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm text-navy hover:bg-gray-50 transition-colors" data-id="element-153">
            <Calendar size={16} className="text-gray-500" data-id="element-154" />
            <span data-id="element-155">{period}</span>
            <ChevronDown size={16} className="text-gray-400" data-id="element-156" />
          </button>
          <button className="p-2 bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-navy hover:bg-gray-50 transition-colors" data-id="element-157">
            <Download size={18} data-id="element-158" />
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-159">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-160">
          <div className="flex justify-between items-start mb-2" data-id="element-161">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-162">
              Guadagni Totali
            </span>
            <div className="p-1.5 bg-green-50 rounded-lg" data-id="element-163">
              <DollarSign className="w-4 h-4 text-green-600" data-id="element-164" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-165">
            <span className="text-2xl font-bold text-green-600" data-id="element-166">€2,450</span>
            <span className="text-xs text-green-600 bg-green-50 px-1.5 py-0.5 rounded flex items-center gap-0.5 mb-1" data-id="element-167">
              <ArrowUpRight size={10} data-id="element-168" /> +12%
            </span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-169">
          <div className="flex justify-between items-start mb-2" data-id="element-170">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-171">
              In Attesa
            </span>
            <div className="p-1.5 bg-amber-50 rounded-lg" data-id="element-172">
              <Clock className="w-4 h-4 text-amber-600" data-id="element-173" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-174">
            <span className="text-2xl font-bold text-navy" data-id="element-175">€340</span>
            <span className="text-xs text-gray-400 mb-1.5" data-id="element-176">
              prossimo bonifico
            </span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-177">
          <div className="flex justify-between items-start mb-2" data-id="element-178">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-179">
              Lavori Completati
            </span>
            <div className="p-1.5 bg-blue-50 rounded-lg" data-id="element-180">
              <CheckCircle className="w-4 h-4 text-blue-600" data-id="element-181" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-182">
            <span className="text-2xl font-bold text-navy" data-id="element-183">52</span>
            <span className="text-xs text-gray-400 mb-1.5" data-id="element-184">
              questa settimana
            </span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-185">
          <div className="flex justify-between items-start mb-2" data-id="element-186">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-187">
              Media / Lavoro
            </span>
            <div className="p-1.5 bg-purple-50 rounded-lg" data-id="element-188">
              <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-189" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-190">
            <span className="text-2xl font-bold text-navy" data-id="element-191">€47</span>
            <span className="text-xs text-green-600 mb-1.5" data-id="element-192">+€2 vs media</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-193">
        {/* Main Chart Section */}
        <div className="lg:col-span-2 bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-194">
          <div className="flex justify-between items-center mb-6" data-id="element-195">
            <h3 className="font-semibold text-navy" data-id="element-196">Andamento Guadagni</h3>
            <div className="flex gap-2" data-id="element-197">
              <span className="text-xs font-medium text-navy bg-gray-100 px-2 py-1 rounded cursor-pointer" data-id="element-198">
                Settimana
              </span>
              <span className="text-xs font-medium text-gray-500 hover:bg-gray-50 px-2 py-1 rounded cursor-pointer transition-colors" data-id="element-199">
                Mese
              </span>
            </div>
          </div>

          {/* Custom SVG Bar Chart */}
          <div className="h-64 w-full relative" data-id="element-200">
            <div className="absolute inset-0 flex items-end justify-between gap-2 sm:gap-4 px-2" data-id="element-201">
              {chartData.map((d, i) => <div key={i} className="flex flex-col items-center gap-2 flex-1 group h-full justify-end" data-id="element-202">
                  <div className="relative w-full max-w-[40px] flex items-end h-full" data-id="element-203">
                    <div className="w-full bg-teal-deep/10 rounded-t-lg group-hover:bg-teal-deep/20 transition-colors relative" style={{
                  height: `${d.value / maxVal * 100}%`
                }} data-id="element-204">
                      <div className="absolute bottom-0 left-0 w-full bg-teal-deep rounded-t-lg transition-all duration-500 ease-out group-hover:bg-teal-600" style={{
                    height: '100%'
                  }} data-id="element-205"></div>

                      {/* Tooltip */}
                      <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-navy text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10" data-id="element-206">
                        €{d.value}
                      </div>
                    </div>
                  </div>
                  <span className="text-xs text-gray-500 font-medium" data-id="element-207">
                    {d.day}
                  </span>
                </div>)}
            </div>
            {/* Grid lines */}
            <div className="absolute inset-0 pointer-events-none flex flex-col justify-between text-xs text-gray-300 -z-10" data-id="element-208">
              <div className="border-b border-gray-100 w-full h-0" data-id="element-209"></div>
              <div className="border-b border-gray-100 w-full h-0" data-id="element-210"></div>
              <div className="border-b border-gray-100 w-full h-0" data-id="element-211"></div>
              <div className="border-b border-gray-100 w-full h-0" data-id="element-212"></div>
              <div className="border-b border-gray-100 w-full h-0" data-id="element-213"></div>
            </div>
          </div>

          {/* Performance Metrics Row */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-214">
            <div data-id="element-215">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-216">
                Efficienza Densità
              </p>
              <p className="text-lg font-bold text-navy flex items-center gap-2" data-id="element-217">
                92/100
                <span className="text-xs font-medium text-green-600 bg-green-50 px-1.5 py-0.5 rounded" data-id="element-218">
                  +12%
                </span>
              </p>
            </div>
            <div data-id="element-219">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-220">
                KM Risparmiati
              </p>
              <p className="text-lg font-bold text-navy" data-id="element-221">45 km</p>
            </div>
            <div data-id="element-222">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-223">
                Ore Risparmiate
              </p>
              <p className="text-lg font-bold text-navy" data-id="element-224">8.5 ore</p>
            </div>
          </div>
        </div>

        {/* Sidebar / Payout Section */}
        <div className="space-y-6" data-id="element-225">
          <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-226">
            <h3 className="font-semibold text-navy mb-4" data-id="element-227">Prossimo Pagamento</h3>
            <div className="bg-gray-50 rounded-lg p-4 mb-4 border border-gray-100" data-id="element-228">
              <p className="text-sm text-gray-500 mb-1" data-id="element-229">Importo stimato</p>
              <p className="text-3xl font-bold text-navy" data-id="element-230">€340,00</p>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-231">
                Disponibile il 10 Febbraio
              </p>
            </div>

            <div className="space-y-3" data-id="element-232">
              <div className="flex items-center gap-3 p-3 border border-gray-100 rounded-lg" data-id="element-233">
                <div className="w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center text-gray-600" data-id="element-234">
                  <CreditCard size={18} data-id="element-235" />
                </div>
                <div className="flex-1" data-id="element-236">
                  <p className="text-sm font-medium text-navy" data-id="element-237">
                    Bonifico Bancario
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-238">IT89 •••• •••• 4521</p>
                </div>
              </div>
              <button className="w-full text-sm text-teal-deep font-medium hover:text-teal-700 transition-colors" data-id="element-239">
                Modifica metodo di pagamento
              </button>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-xl p-5" data-id="element-240">
            <h4 className="font-semibold text-blue-900 text-sm mb-2" data-id="element-241">
              Ottimizza i tuoi guadagni
            </h4>
            <p className="text-xs text-blue-700 mb-3 leading-relaxed" data-id="element-242">
              La tua densità media è aumentata del 12%. Accettando più pacchetti
              nella Zona Prati potresti incrementare i guadagni del 15%.
            </p>
            <button className="text-xs font-bold text-blue-800 hover:text-blue-900" data-id="element-243">
              Vedi opportunità Zona Prati →
            </button>
          </div>
        </div>
      </div>

      {/* Transactions List */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-244">
        <div className="p-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-245">
          <h3 className="font-semibold text-navy" data-id="element-246">Transazioni Recenti</h3>
          <div className="flex gap-2" data-id="element-247">
            <button className="flex items-center gap-2 px-3 py-1.5 border border-gray-200 rounded-lg text-xs font-medium text-gray-600 hover:bg-gray-50" data-id="element-248">
              <Filter size={14} data-id="element-249" /> Filtra
            </button>
            <button className="flex items-center gap-2 px-3 py-1.5 border border-gray-200 rounded-lg text-xs font-medium text-gray-600 hover:bg-gray-50" data-id="element-250">
              <Download size={14} data-id="element-251" /> Export CSV
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-252">
          <table className="w-full text-sm text-left" data-id="element-253">
            <thead className="bg-gray-50 text-gray-500 font-medium border-b border-gray-200" data-id="element-254">
              <tr data-id="element-255">
                <th className="px-6 py-3 w-32" data-id="element-256">Data</th>
                <th className="px-6 py-3" data-id="element-257">Descrizione</th>
                <th className="px-6 py-3" data-id="element-258">Lavori</th>
                <th className="px-6 py-3" data-id="element-259">Importo</th>
                <th className="px-6 py-3" data-id="element-260">Stato</th>
                <th className="px-6 py-3 text-right" data-id="element-261">Azioni</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-262">
              {transactions.map(tx => <tr key={tx.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-263">
                  <td className="px-6 py-4 text-gray-500" data-id="element-264">{tx.date}</td>
                  <td className="px-6 py-4 font-medium text-navy" data-id="element-265">{tx.desc}</td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-266">
                    <span className="inline-flex items-center gap-1.5 bg-gray-100 px-2 py-0.5 rounded text-xs" data-id="element-267">
                      <Clock size={12} data-id="element-268" /> {tx.jobs}
                    </span>
                  </td>
                  <td className="px-6 py-4 font-bold text-navy" data-id="element-269">{tx.amount}</td>
                  <td className="px-6 py-4" data-id="element-270">{getStatusBadge(tx.status)}</td>
                  <td className="px-6 py-4 text-right" data-id="element-271">
                    <button className="text-gray-400 hover:text-navy transition-colors" data-id="element-272">
                      <Download size={16} data-id="element-273" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="p-4 border-t border-gray-200 text-center" data-id="element-274">
          <button className="text-sm font-medium text-teal-deep hover:text-teal-700 transition-colors" data-id="element-275">
            Carica altre transazioni
          </button>
        </div>
      </div>
    </div>;
}